import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href || window.location.href,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600 py-4">
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      {items.map((item, index) => (
        <span key={index} className="flex items-center">
          {index > 0 && (
            <i className="ri-arrow-right-s-line mx-2 text-foreground-400"></i>
          )}
          {item.href && index < items.length - 1 ? (
            <Link
              to={item.href}
              className="hover:text-primary-500 transition-colors duration-200"
            >
              {item.label}
            </Link>
          ) : (
            <span className={index === items.length - 1 ? 'text-foreground-900 font-medium' : ''}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}